import SubPrice from './SubPrice.component';
export default SubPrice;